// 页面数据
export const pageData = [
    // 第一章节
    {
        section   : true,
        title     : '第一章',
        videoUrl  : require('../../assets/img/video/1.mp4'),
        videoName : '纪录片《红旗渠》',
        list      : [
            {   
                name   :'困扰林县人民千年的旱魔',
                goPage : 6
            },
            {   
                name   :'重新安排林县河山',
                goPage : 7
            },
            {   
                name   :'再大的困难也难不住伟大的林县人民',
                goPage : 11
            },
            {   
                name   :'英雄集体',
                goPage : 15
            },
            {   
                name   :'谁说女子不如男',
                goPage : 16
            },
            {   
                name   :'英雄个人',
                goPage : 17
            },
            {   
                name   :'人民是历史的创造者',
                goPage : 22
            },
            {   
                name   :'虽苦尤甜的工地生活',
                goPage : 26
            },
            {   
                name   :'最简单的工具',
                goPage : 30
            }
        ]
    },
    // 01. 困扰林县人民千年的旱魔
    {
        num        : '01',
        title      : '困扰林县人民千年的旱魔',
        content    : `在千年历史中，林县是一个山高坡陡、土薄石厚、水源奇缺、十年九旱的贫瘠山区，当地民谣形容缺水情况：天旱把雨盼，雨大冲一片，\n卷走黄沙土，留下石头蛋。新中国成立后，水是制约林县人民生存和发展的最大障碍。`,
        img_1      : require('../../assets/img/page/6-1.jpg'),
        img_2      : require('../../assets/img/page/6-2.jpg'),
        img_1Title : '修渠前群众吃水困难，要跑到十几里外取水',
        img_2Title : '修渠前群众深井打水',
        page       : 1
    },
    // 02. 重新安排林县河山
    {
        num        : '02',
        title      : '重新安排林县河山',
        content    : `县委书记杨贵在林县常委扩大会议上说：“解放后，林县人民在政治上翻了身，做了社会的主人后，迫切要求在经济上再来个翻身。\n现在，仍然有‘三座大山’压在林县人民头上……水又是第一个也是最大的障碍……\n共产党的县委绝不能看着人民群众长期受缺水之苦而无动于衷。”\n他向林县人民庄严宣布：“全党动手，全民动员，苦战五年，重新安排林县河山。\n”跨越太行山，修建红旗渠，是林县从根本上解决缺水状况的最优方案。`,
        img_1      : require('../../assets/img/page/6-3.jpg'),
        img_1Title : '引漳入林动员令',
        word       : '1960年2月10日，林县引漳入林总指挥部向全县人民发出《引漳入林动员令》，吹响了红旗渠建设的号角。',
        page       : 2
    },
    {
        num        : '02',
        title      : '重新安排林县河山',
        img_1      : require('../../assets/img/page/6-4.jpg'),
        img_2      : require('../../assets/img/page/6-5.jpg'),
        img_1Title : '千军万马上太行',
        img_2Title : '林县县委书记杨贵走在群众前面',
        page       : 3
    },
    {
        num        : '02',
        title      : '重新安排林县河山',
        img_1      : require('../../assets/img/page/6-6.jpg'),
        img_1Title : '杨贵同志深入基层访问群众',
        word       : `杨贵担任林县县委书记后，多次组织干部深入群众，调查研究。\n 经过反复论证，杨贵决心带领全县人民修建红旗渠，重新安排林县河山。`,
        page       : 4
    },
    {
        num        : '02',
        title      : '重新安排林县河山',
        img_1      : require('../../assets/img/page/6-7.jpg'),
        img_2      : require('../../assets/img/page/6-8.jpg'),
        img_1Title : '勘察现场',
        img_2Title : '杨贵在施工现场',
        page       : 5
    },

    // 03. 再大的困难也难不住伟大的林县人民
    {
        num        : '03',
        title      : '再大的困难也难不住伟大的林县人民',
        content    : `红旗渠工程启动时，面临工具不足、水泥不足、技术不足等重重困难，林县人民不等不靠，积极发挥集体聪明才智，\n 没有炸药自己做，没有工具自己造，没有成熟技术土法也要上，保证了红旗渠工程修筑的顺利开展。`,
        img_1      : require('../../assets/img/page/6-9.jpg'),
        img_2      : require('../../assets/img/page/6-10.jpg'),
        img_1Title : '放炮开山',
        img_2Title : '劈开太行万重山',
        page       : 6
    },
    {
        num        : '03',
        title      : '再大的困难也难不住伟大的林县人民',
        img_1      : require('../../assets/img/page/6-11.jpg'),
        img_1Title : '凌空除险',
        word       : `红旗渠修筑过程中，山上碎石时常掉落，砸伤不少修渠群众，除险队由此建立。\n 队员们将大绳一头固定到山顶，一头系在腰间，慢慢由山顶缒下，找到碎石后及时清除，大大降低了施工风险。`,
        page       : 7
    },
    {
        num        : '03',
        title      : '再大的困难也难不住伟大的林县人民',
        img_1      : require('../../assets/img/page/6-12.jpg'),
        img_1Title : '独轮车显神威',
        word       : '红旗渠是炮崩出来的，也是独轮车推出来的。独轮车是修渠物资运输的主要工具。',
        page       : 8
    },
    {
        num        : '03',
        title      : '再大的困难也难不住伟大的林县人民',
        img_1      : require('../../assets/img/page/6-13.jpg'),
        img_1Title : '能工巧匠各显其能',
        word       : '没有炸药自己制，没有工具自己造，修渠民工中的能工巧匠，不断为工地制造工具，提高生产效率。',
        page       : 9
    },
    // 04. 英雄集体
    {
        num        : '04',
        title      : '英雄集体',
        content    : '红旗渠修筑过程中，林县男女老少齐上阵，各尽所能，为红旗渠建设添砖加瓦，红旗渠的每块砖石都凝结着林县人民的辛勤汗水。',
        img_1      : require('../../assets/img/page/6-14.jpg'),
        img_2      : require('../../assets/img/page/6-15.jpg'),
        img_3      : require('../../assets/img/page/6-16.jpg'),
        img_1Title : '老石匠',
        img_2Title : '青年突击队',
        img_3Title : '知识青年劳动',
        page       : 10
    },
    // 05. 谁说女子不如男
    {
        num        : '05',
        title      : '谁说女子不如男',
        content    : '林县姑娘们干劲儿十足，她们不惧繁重的体力劳动，与男儿们一样开山凿石、修筑水渠，尽显巾帼英姿。',
        img_1      : require('../../assets/img/page/6-17.jpg'),
        img_2      : require('../../assets/img/page/6-18.jpg'),
        img_3      : require('../../assets/img/page/6-19.jpg'),
        img_1Title : '女石匠',
        img_2Title : '工地铁姑娘',
        img_3Title : '为红旗渠精心填泥缝的姑娘们',
        page       : 11
    },
    // 06. 英雄个人
    {
        num        : '06',
        title      : '英雄个人',
        content    : ` 红旗渠建设过程中，哪里有困难，哪里就有英雄涌现，任羊成主动请缨到悬崖上除险，\n 常根虎放炮炸开万重山，王师存数月不出山洞忙开凿，路银土法测量精准指导施工……`,
        img_1      : require('../../assets/img/page/6-20.jpg'),
        img_1Title : '除险英雄——任羊成',
        word       : `为了保证施工安全，任羊成带领除险队员终日悬荡于峭壁之上，冒着生命危险，清除残碎石块。\n 在一次高空除险时，一块从头顶落下的石头砸掉了他的四颗门牙。`,
        page       : 12
    },
    {
        num        : '06',
        title      : '英雄个人',
        img_1      : require('../../assets/img/page/6-21.jpg'),
        img_1Title : '英雄炮手——常根虎',
        word       : `红旗渠总干渠可以说是用炮崩出来的。逢山劈山，遇岭凿洞，全靠炮崩，而放炮又全靠人工点燃，稍有不慎就会粉身碎骨。\n 常虎根凭着他的勇敢机智，带领炮手在悬崖凿眼、装药放炮数以万次，被人们誉为“爬山虎”“神炮手”。`,
        page       : 13
    },
    {
        num        : '06',
        title      : '英雄个人',
        img_1      : require('../../assets/img/page/6-22.jpg'),
        img_1Title : '凿洞能手——王师存',
        word       : `修建长800多米的曙光洞时，因为洞身要经过村庄，不能放炮，全靠一锤一钎的开凿。王师存连续数月没走出山洞，\n 洞内塌方、缺氧、断水、断电，他毫不畏惧。在他的带领下，曙光洞开凿工程如期完工，保证了三干渠按时通水。`,
        page       : 14
    },
    {
        num        : '06',
        title      : '英雄个人',
        img_1      : require('../../assets/img/page/6-23.jpg'),
        img_1Title : '农民水利技术员——路银',
        word       : `农民水利技术员路银，被群众称为“农民水利专家”。70.6公里总干渠在他指导下，\n 纵坡为1/8000，就连现在的设备与技术，也很难达到这个指标。`,
        page       : 15
    },
    {
        num        : '06',
        title      : '英雄个人',
        img_1      : require('../../assets/img/page/6-24.jpg'),
        img_1Title : '红旗渠指挥部指挥长——马有金',
        word       : `在红旗渠指挥部，任职时间最长的指挥长就是马有金。\n 他长年累月奔走在工地上，脸被太阳晒得黑乎乎的，所以被大家誉为“黑老马”。`,
        page       : 16
    },
    // 07. 人民是历史的创造者
    {
        num        : '07',
        title      : '人民是历史的创造者',
        content    : `红旗渠建设工地上，处处都有人民群众热火朝天奋战的场景。`,
        img_1      : require('../../assets/img/page/6-25.jpg'),
        img_1Title : '土法建设桃园渡槽',
        word       : '红旗渠上150多座渡槽就是这样建设起来的。一筐筐土、一方方石、一根根柱，全靠劳动人民的一双手。',
        page       : 17
    },
    {
        num        : '07',
        title      : '人民是历史的创造者',
        img_1      : require('../../assets/img/page/6-26.jpg'),
        img_1Title : '修建中的夺丰渡槽',
        word       : '在这座长数百米的夺丰渡槽施工工地上，找不到一件铁质工具，因为这一方方石块都是民工们用木吊杆拉上桥顶的。',
        page       : 18
    },
    {
        num        : '07',
        title      : '人民是历史的创造者',
        img_1      : require('../../assets/img/page/6-27.jpg'),
        img_2      : require('../../assets/img/page/6-28.jpg'),
        img_1Title : '悬崖砌渠',
        img_2Title : '现场观摩学习',
        page       : 19
    },
    {
        num        : '07',
        title      : '人民是历史的创造者',
        img_1      : require('../../assets/img/page/6-29.jpg'),
        img_1Title : '严谨施工 一丝不苟',
        word       : '红旗渠千年大计，工程质量第一，指挥部领导和工程人员现场指导，一丝不苟，精心检查施工质量。',
        page       : 20
    },

    // 08. 虽苦尤甜的工地生活
    {
        num        : '08',
        title      : '虽苦尤甜的工地生活',
        content    : `红旗渠建设者们不仅要应对施工上的困难，还要面对艰苦枯燥的生活环境。他们因陋就简，没有房屋就睡在山洞里，\n 自编自演娱乐节目，组织扁担运输队运输生活用品……再苦再难也拦不住大家将红旗渠建设到底的决心。`,
        img_1      : require('../../assets/img/page/6-30.jpg'),
        img_2      : require('../../assets/img/page/6-31.jpg'),
        img_1Title : '工地宣传员',
        img_2Title : '赤脚医生在工地',
        page       : 21
    },
    {
        num        : '08',
        title      : '虽苦尤甜的工地生活',
        img_1      : require('../../assets/img/page/6-32.jpg'),
        img_1Title : '送货',
        word       : '石板岩供销社的社员们长年坚持翻山越岭把修渠民工需要的生活用品用扁担挑到工地。',
        page       : 22
    },
    {
        num        : '08',
        title      : '虽苦尤甜的工地生活',
        img_1      : require('../../assets/img/page/6-33.jpg'),
        img_1Title : '山洞里安营扎寨',
        word       : '修渠民工吃住在山洞，有时候甚至以蓝天为被、大地为床，露营在山野。',
        page       : 23
    },
    {
        num        : '08',
        title      : '虽苦尤甜的工地生活',
        img_1      : require('../../assets/img/page/6-34.jpg'),
        img_2      : require('../../assets/img/page/6-35.jpg'),
        img_1Title : '上山修渠不忘学习',
        img_2Title : '自编自演文艺节目',
        page       : 24
    },
    // 09. 最简单的工具 
    {
        num        : '09',
        title      : '最简单的工具',
        content    : `伟大的红旗渠就是借助这些最简单、最普通的用具一锤一锨建起来的。`,
        img_1      : require('../../assets/img/page/6-36.jpg'),
        img_2      : require('../../assets/img/page/6-37.jpg'),
        img_1Title : '马灯',
        img_2Title : '柳帽',
        page       : 25
    },
    {
        num        : '09',
        title      : '最简单的工具',
        img_1      : require('../../assets/img/page/6-38.jpg'),
        img_2      : require('../../assets/img/page/6-39.jpg'),
        img_3      : require('../../assets/img/page/6-40.jpg'),
        img_1Title : '勾缝匙',
        img_2Title : '洋镐',
        img_3Title : '撅头',
        page       : 26
    },
    {
        num        : '09',
        title      : '最简单的工具',
        img_1      : require('../../assets/img/page/6-41.jpg'),
        img_2      : require('../../assets/img/page/6-42.jpg'),
        img_3      : require('../../assets/img/page/6-43.jpg'),
        img_1Title : '大锤',
        img_2Title : '除险钩',
        img_3Title : '小推车、抬筐',
        page       : 27
    },
    // 第二章节
    {
        section   : true,
        title     : '第二章',
        videoUrl  : require('../../assets/img/video/2.mp4'),
        videoName : '纪录片《红旗渠》',
        list      : [
            {
                name   : '红旗渠工程总体规划',
                goPage : 34
            },
            {
                name   : '红旗渠重要工程',
                goPage : 36
            }
        ]
    },
    // 01. 红旗渠工程总体规划
    {
        num        : '01',
        title      : '红旗渠工程总体规划',
        content    : `林县县委和县政府在红旗渠开工之前进行了多年调查勘探和酝酿准备，\n 对渠线的选择、物资的储备、人力的投入等都做了详细规划，兼顾了科学性和可行性，为红旗渠胜利建成打下了坚实的基础。`,
        img_1      : require('../../assets/img/page/6-44.jpg'),
        img_1Title : '引漳入林总干渠示意图',
        page       : 28
    },
    {
        num        : '01',
        title      : '红旗渠工程总体规划',
        img_1      : require('../../assets/img/page/6-45.jpg'),
        img_1Title : '航拍总干渠',
        word       : '红旗渠像一条银色的飘带，紧紧地萦绕在太行山腰。',
        page       : 29
    },
    // 02. 红旗渠重要工程
    {
        num        : '02',
        title      : '红旗渠重要工程',
        content    : `红旗渠建设过程中，为了使渠水能够源源不断地由山西平顺县浊漳河渠源流入林县大地，林县人民削平了1250座山头，\n 架设了151座渡槽，开凿了211个隧洞，修建了各种建筑物12408座，挖砌的土石方达2225万立方米，使太行山由天堑变为通途。`,
        img_1      : require('../../assets/img/page/6-46.jpg'),
        img_1Title : '红旗渠渠源',
        word       : '红旗渠渠源位于山西平顺县，浊漳河在这里被拦腰截流，引上太行山。',
        page       : 30
    },
    {
        num        : '02',
        title      : '红旗渠重要工程',
        img_1      : require('../../assets/img/page/6-47.jpg'),
        img_1Title : '渠头进水闸',
        page       : 31
    },
    {
        num        : '02',
        title      : '红旗渠重要工程',
        img_1      : require('../../assets/img/page/6-48.jpg'),
        img_1Title : '空心坝',
        word       : `这是红旗渠上一座比较独特的建筑物。它使渠水坝中流，河水坝上过，解决了在同一个水平面上河水与\n 渠水交叉流过的问题。它是群众智慧的结晶。这座弓形空心坝坐落在白家庄西边浊河上，长150米，宽20米，2个孔眼，\n 每孔宽3米，高4.5米，共挖土石方5624立方米。`,
        page       : 32
    },
    {
        num        : '02',
        title      : '红旗渠重要工程',
        img_1      : require('../../assets/img/page/6-49.jpg'),
        img_1Title : '青年洞',
        word       : `1960年2月，当总干渠修到狼牙山“小鬼脸”时，一边高山挡道，一边悬崖峭壁，除了开山凿洞，别无他法。\n 红旗渠工程指挥部当即决定，组织一支青年突击队来征服这一天险。300多名青年经过17个月的英勇奋战，\n 终于凿通了这个岩石隧洞。`,
        page       : 33
    },
    {
        num        : '02',
        title      : '红旗渠重要工程',
        img_1      : require('../../assets/img/page/6-50.jpg'),
        img_1Title : '长藤结瓜  渠畔明珠',
        word       : '为了充分发挥红旗渠的作用，林县人民沿渠修建小水库175座，把平常不用的水蓄起来，似长藤结瓜，遍地开花。',
        page       : 34
    },
    {
        num        : '02',
        title      : '红旗渠重要工程',
        img_1      : require('../../assets/img/page/6-51.jpg'),
        img_1Title : '南谷洞水库',
        word       : '南谷洞水库拦截的是露河水，修建有一、二级输水洞，可以通过二级输水洞，把库水输入红旗渠总干渠。',
        page       : 35
    },
    {
        num        : '02',
        title      : '红旗渠重要工程',
        img_1      : require('../../assets/img/page/6-52.jpg'),
        img_1Title : '弓上水库',
        word       : '弓上水库蓄的是淅河水，为英雄渠渠源。英雄渠现已并为红旗渠一干渠。',
        page       : 36
    },
    {
        num        : '02',
        title      : '红旗渠重要工程',
        img_1      : require('../../assets/img/page/6-53.jpg'),
        img_1Title : '南古洞水库大坝',
        word       : '南谷洞水库大坝，高78米，坝长164米，坝底宽241米，顶宽9.5米，全用石块砌成。',
        page       : 37
    },
    {
        num        : '02',
        title      : '红旗渠重要工程',
        img_1      : require('../../assets/img/page/6-54.jpg'),
        img_2      : require('../../assets/img/page/6-55.jpg'),
        img_1Title : '王家庄泄洪闸',
        img_2Title : '南谷洞十孔大渡槽',
        page       : 38
    },
    {
        num        : '02',
        title      : '红旗渠重要工程',
        img_1      : require('../../assets/img/page/6-56.jpg'),
        img_1Title : '雄伟的曙光渡槽',
        word       : `曙光渡槽是红旗渠最长的一座渡槽，坐落在东岗公社丁冶村西岭上，全长550米，高16米，有29个桥孔。\n 过水断面高1米，宽1.1米，每秒过水流量为1立方米。`,
        page       : 39
    },
    {
        num        : '02',
        title      : '红旗渠重要工程',
        img_1      : require('../../assets/img/page/6-57.jpg'),
        img_1Title : '高耸的桃园渡槽',
        word       : `桃园渡槽是红旗渠最高的一座建筑物，坐落在城关公社桃园村南的桃园河上。\n 全长100米，高24米，宽6米。桥下过洪水，桥中流渠水，桥上能通行车辆。`,
        page       : 40
    },
    // 第三章节
    {
        section   : true,
        title     : '第三章',
        videoUrl  : require('../../assets/img/video/3.mp4'),
        videoName : '纪录片《红旗渠》',
        list      : [
            {
                name   : '红旗渠不仅是林县的，更是中国的',
                goPage : 48
            },
            {
                name   : '祖祖辈辈的梦想变为现实',
                goPage : 50
            },
            {
                name   : '红旗渠水浇灌林县大地',
                goPage : 53
            },
            {
                name   : '幸福的生活',
                goPage : 57
            }
        ]
    },
    // 01. 红旗渠不仅是林县的，更是中国的
    {
        num        : '01',
        title      : '红旗渠不仅是林县的，更是中国的',
        content    : `红旗渠修建的前前后后，受到了党和国家高度重视。《人民日报》对红旗渠进行了多次专题报道。`,
        img_1      : require('../../assets/img/page/6-58.jpg'),
        img_1Title : '1965年12月18日《人民日报》头版头条对红旗渠的报道',
        word       : `报道以《党的领导无所不在——记河南林县人民在党的领导下重新安排河山的斗争》为题，\n 对林县红旗渠修筑的背景、过程、意义进行了详细介绍。`,
        page       : 41
    },
    {
        num        : '01',
        title      : '红旗渠不仅是林县的，更是中国的',
        img_1      : require('../../assets/img/page/6-59.jpg'),
        img_1Title : '1966年4月21日《人民日报》对红旗渠的报道',
        word       : `报道以《毛泽东思想引领林县人民修成了红旗渠》为题，发布了红旗渠竣工通水的消息，\n 讲述了红旗渠竣工庆祝大会的实况，对红旗渠建设的意义和成功的原因进行了深入剖析。`,
        page       : 42
    },
    // 02. 祖祖辈辈的梦想变为现实
    {
        num        : '02',
        title      : '祖祖辈辈的梦想变为现实',
        content    : `林县人民祖祖辈辈的梦想是有一天吃水再也不用到远处挑了，红旗渠的通水使梦想成真。`,
        img_1      : require('../../assets/img/page/6-60.jpg'),
        img_1Title : '盛大的节日',
        word       : `1965年，红旗渠总干渠胜利建成。浊漳河水终于引入林县，实现了林县人民梦寐以求的愿望。\n 4月5日林县在红旗渠分水岭举行了隆重的通水典礼，十几万群众像过大年一样从四面八方汇聚到分水岭，共同见证这一历史时刻。`,
        page       : 43
    },
    {
        num        : '02',
        title      : '祖祖辈辈的梦想变为现实',
        img_1      : require('../../assets/img/page/6-61.jpg'),
        img_1Title : '三干渠通水典礼',
        word       : `1966年，一、二、三干渠全线建成并通水。三条干渠通水后，林县人民又继续完成支渠配套工程。\n 这是一、二、三干渠建成后的通水典礼。`,
        page       : 44
    },
    {
        num        : '02',
        title      : '祖祖辈辈的梦想变为现实',
        img_1      : require('../../assets/img/page/6-62.jpg'),
        img_2      : require('../../assets/img/page/6-63.jpg'),
        img_1Title : '浊漳河水流入林县大地',
        img_2Title : '亲眼见证梦想成真',
        page       : 45
    },
    // 03. 红旗渠水浇灌林县大地
    {
        num        : '03',
        title      : '红旗渠水浇灌林县大地',
        content    : `红旗渠通水后，首先带来林县农业生产潜力的巨大释放，林县发展了大量配套水利工程，把红旗渠水引入田间地头，林县大地处处丰收在望。`,
        img_1      : require('../../assets/img/page/6-64.jpg'),
        img_1Title : '渠道绕山头',
        word       : `这是红旗渠一干渠鸟瞰图。过去“十年九旱，水贵如油”的穷山沟，\n 如今是“渠道绕山头，清水遍地流；旱涝都不怕，年年保丰收”。`,
        page       : 46
    },
    {
        num        : '03',
        title      : '红旗渠水浇灌林县大地',
        img_1      : require('../../assets/img/page/6-65.jpg'),
        img_1Title : '平地配套工程遍地开花',
        word       : '红旗渠总干渠建成了，林县人民意气风发大搞渠道配套工程，修建支渠，平整土地，沿渠修建小水库。',
        page       : 47
    },
    {
        num        : '03',
        title      : '红旗渠水浇灌林县大地',
        img_1      : require('../../assets/img/page/6-66.jpg'),
        img_1Title : '渠水流入田间地头',
        page       : 48
    },
    {
        num        : '03',
        title      : '红旗渠水浇灌林县大地',
        img_1      : require('../../assets/img/page/6-67.jpg'),
        img_1Title : '干旱地区变江南',
        word       : '任村公社古城大队引用红旗渠水种植的大面积水稻田。',
        page       : 49
    },

    // 04. 幸福的生活'
    {
        num        : '04',
        title      : '幸福的生活',
        content    : `在粮食连年丰收的基础上，林县发展水产养殖、果树种植、水利发电等多种事业，使人民生活节节高。`,
        img_1      : require('../../assets/img/page/6-68.jpg'),
        img_1Title : '晚谷喜丰收',
        page       : 50
    },
    {
        num        : '04',
        title      : '幸福的生活',
        img_1      : require('../../assets/img/page/6-69.jpg'),
        img_1Title : '收割忙',
        word       : '1969年6月，在红旗渠水的灌溉下，林县小麦喜获丰收。',
        page       : 51
    },
    {
        num        : '04',
        title      : '幸福的生活',
        img_1      : require('../../assets/img/page/6-70.jpg'),
        img_2      : require('../../assets/img/page/6-71.jpg'),
        img_1Title : '丰收场上',
        img_2Title : '粮食归仓',
        page       : 52
    },
    {
        num        : '04',
        title      : '幸福的生活',
        img_1      : require('../../assets/img/page/6-72.jpg'),
        img_1Title : '踊跃交公粮',
        word       : '红旗渠通水后，林县粮食产量实现历史跨越，丰收不忘国家，农民踊跃向国家交售公粮。',
        page       : 53
    },
    {
        num        : '04',
        title      : '幸福的生活',
        img_1      : require('../../assets/img/page/6-73.jpg'),
        img_1Title : '水塘养鱼',
        page       : 54
    },
    {
        num        : '04',
        title      : '幸福的生活',
        img_1      : require('../../assets/img/page/6-74.jpg'),
        img_2      : require('../../assets/img/page/6-75.jpg'),
        img_3      : require('../../assets/img/page/6-76.jpg'),
        img_1Title : '培育珍珠',
        img_2Title : '棉花丰产',
        img_3Title : '苹果丰收',
        page       : 55
    },
    {
        num        : '04',
        title      : '幸福的生活',
        img_1      : require('../../assets/img/page/6-77.jpg'),
        img_1Title : '水泥厂',
        word       : '林县水泥厂发扬红旗渠精神，没有工具自己打，没有水泥自己造，大大促进了地方工业的发展。',
        page       : 56
    },
    {
        num        : '04',
        title      : '幸福的生活',
        img_1      : require('../../assets/img/page/6-78.jpg'),
        img_2      : require('../../assets/img/page/6-79.jpg'),
        img_1Title : '红旗渠上的小型发电站',
        img_2Title : '群众用上了红旗渠水发的电',
        page       : 57
    },

    // 第四章节
    {
        section   : true,
        title     : '第四章',
        videoUrl  : 'https://baijiahao.baidu.com/s?id=1748104422243674518&wfr=spider&for=pc',
        videoName : '定叫山河换新装-习近平总书记考察红旗渠纪实',
        list      : [
            {
                name   : '总书记的关怀',
                goPage : 66
            },
            {
                name   : '新时代新林州',
                goPage : 70
            },
            {
                name   : '铭记历史',
                goPage : 76
            }
        ]
    },
    
    // 01. 总书记的关怀
    {
        num        : '01',
        title      : '总书记的关怀',
        content    : `习近平总书记对红旗渠精神高度重视，多次强调红旗渠精神在中国共产党人精神谱系中的重要地位。\n 他指出：“焦裕禄精神、红旗渠精神、大别山精神等都是我们党的宝贵精神财富。”\n “愚公移山精神、焦裕禄精神、红旗渠精神，这些革命创新精神是我们党的性质和宗旨的集中体现，历久弥新，永远不会过时。”\n 在党和国家迈上全面建设社会主义现代化国家新征程、向第二个百年奋斗目标进军的关键时刻，\n 习近平总书记专程来到红旗渠，深入阐述红旗渠精神在新时代的巨大意义。`,
        page       : 58
    },
    {
        num        : '01',
        title      : '总书记的关怀',
        content    : `2022年10月28日上午，习近平总书记来到河南安阳林州市红旗渠纪念馆。\n 习近平总书记指出：“红旗渠就是纪念碑，记载了林县人不认命、不服输、敢于战天斗地的英雄气概。\n 要用红旗渠精神教育人民特别是广大青少年，社会主义是拼出来、干出来、拿命换来的，不仅过去如此，新时代也是如此。\n 没有老一辈人拼命地干，没有他们付出的鲜血乃至生命，就没有今天的幸福生活，我们要永远铭记他们。\n 今天，物质生活大为改善，但愚公移山、艰苦奋斗的精神不能变。红旗渠很有教育意义，大家都应该来看看。”`,
        img_1      : require('../../assets/img/page/6-80.jpg'),
        img_1Title : '习近平总书记在安阳林州市红旗渠纪念馆参观',
        page       : 59
    },
    {
        num        : '01',
        title      : '总书记的关怀',
        content    : `习近平总书记实地察看红旗渠分水闸运行情况，详细了解分水闸在调水、灌溉、改善生态环境等方面的重要作用。`,
        img_1      : require('../../assets/img/page/6-81.jpg'),
        img_1Title : '习近平总书记实地察看红旗渠分水闸运行情况',
        page       : 60
    },
    {
        num        : '01',
        title      : '总书记的关怀',
        content    : `习近平总书记来到青年洞，沿步道察看红旗渠。他强调：“红旗渠精神同延安精神是一脉相承的，\n 是中华民族不可磨灭的历史记忆，永远震撼人心。年轻一代要继承和发扬吃苦耐劳、自力更生、艰苦奋斗的精神，摒弃骄娇二气，\n 像我们的父辈一样把青春热血镌刻在历史的丰碑上。实现第二个百年奋斗目标也就是一两代人的事，\n 我们正逢其时、不可辜负，要作出我们这一代的贡献。红旗渠精神永在！”`,
        img_1      : require('../../assets/img/page/6-82-1.jpg'),
        img_1Title : '习近平总书记考察红旗渠青年洞',
        page       : 61
    },

    // 02. 新时代新林州
    {
        num        : '02',
        title      : '新时代新林州',
        content    : `红旗渠精神是一面永恒的旗帜。走在新的赶考路上，林州市始终大力弘扬红旗渠精神，不断赋予新的时代内涵，\n 坚定不移实现高质量发展，以“誓把河山重安排”的豪迈气概，全面开启高质量建设中等城市新征程。`,
        img_1      : require('../../assets/img/page/6-83.jpg'),
        img_2      : require('../../assets/img/page/6-84.jpg'),
        img_1Title : '今日红旗渠',
        img_2Title : '红旗渠青年洞',
        page       : 62
    },
    {
        num        : '02',
        title      : '新时代新林州',
        img_1      : require('../../assets/img/page/6-85.jpg'),
        img_2      : require('../../assets/img/page/6-86.jpg'),
        img_1Title : '迎宾大桥',
        img_2Title : '农民丰收节开幕式',
        page       : 63
    },
    {
        num        : '02',
        title      : '新时代新林州',
        img_1      : require('../../assets/img/page/6-87.jpg'),
        img_2      : require('../../assets/img/page/6-88.jpg'),
        img_1Title : '辣椒丰收',
        img_2Title : '863红旗渠科技产业园',
        page       : 64
    },
    {
        num        : '02',
        title      : '新时代新林州',
        img_1      : require('../../assets/img/page/6-89.jpg'),
        img_2      : require('../../assets/img/page/6-90.jpg'),
        img_1Title : '河南光远新材料生产线',
        img_2Title : '南水北调西部调水工程',
        page       : 65
    },
    {
        num        : '02',
        title      : '新时代新林州',
        img_1      : require('../../assets/img/page/6-91.jpg'),
        img_2      : require('../../assets/img/page/6-92.jpg'),
        img_1Title : '红旗渠隧道',
        img_2Title : '山水林州',
        page       : 66
    },
    {
        num        : '02',
        title      : '新时代新林州',
        img_1      : require('../../assets/img/page/6-93.jpg'),
        img_1Title : '守渠人王清海',
        word       : `王清海的爷爷是修渠人，父亲是护渠人，一家三代都与红旗渠有缘。1991年，王清海接替父亲，成为红旗渠王家庄管理段一名护渠人。\n 这里地势险要，渠线在太行山半山腰上，王清海负责其中2公里，记录水量、清除渠内外的障碍物，来回走一趟需要2个多小时，\n 每天需要巡查两至三次，雨季汛期还要加班巡查，防止险情发生，守好关系林州人命运的“幸福渠”。`,
        page       : 67
    },
    // 03. 链接???????
    {
        videoState   : true,
        num          : '03',
        title        : '铭记历史',
        videoUrl     : 'https://haokan.baidu.com/v?pd=wisenatural&vid=3865716784884883181',
        imgUrl       : require('../../assets/img/1.png'),
        videoName    : '纪录片 《红旗渠》',
        page         : 68
    },
    {
        videoState   : true,
        num          : '03',
        title        : '铭记历史',
        videoUrl     : 'https://www.bilibili.com/video/BV1jq4y1z78J?p=10&vd_source=c01d0fa3a8580684746d55049a531251',
        imgUrl       : require('../../assets/img/2.png'),
        videoName    : '中国共产党人精神谱系41集微视频',
        page         : 69
    },
    {
        num        : '03',
        title      : '铭记历史',
        img_1      : require('../../assets/img/page/6-94.jpg'),
        img_1Title : '摄影记者魏德忠讲述红旗渠',
        word       : `20世纪60年代，《河南日报》摄影记者魏德忠跟随红旗渠的修筑进行了长达10年的拍照和记录。\n 他与修渠民工同吃同住，踏遍了红旗渠两岸的山山水水，用镜头定格了红旗渠建设者许多难忘的瞬间，\n 生动记录了红旗渠精神孕育、形成、发扬的全过程。`,
        page       : 70
    },
    {
        videoState : true,
        num        : '03',
        title      : '学习',
        videoUrl   : 'https://haokan.baidu.com/v?pd=wisenatural&vid=10849339699042456201',
        imgUrl       : require('../../assets/img/3.png'),
        videoName  : '十年跟拍 影像见证红旗渠修建过程',
        page       : 71
    },
]
// 导航数据
export const navData = [
    {
        name 	: '首页',
        section : true,
        goPage  : 1
    },
    {
        name 	: '第一章 艰苦奋斗',
        section : true,
        goPage  : 5
    },
    {   
        name   :'01 困扰林县人民千年的旱魔',
        goPage : 6,
        page   : 1
    },
    {   
        name   :'02 重新安排林县河山',
        goPage : 7,
        page   : 2
    },
    {   
        name   :'03 再大的困难也难不住伟大的林县人民',
        goPage : 11,
        page   : 6
    },
    {   
        name   :'04 英雄集体',
        goPage : 15,
        page   : 10
    },
    {   
        name   :'05 谁说女子不如男',
        goPage : 16,
        page   : 11
    },
    {   
        name   :'06 英雄个人',
        goPage : 17,
        page   : 12
    },
    {   
        name   :'07 人民是历史的创造者',
        goPage : 22,
        page   : 17
    },
    {   
        name   :'08 虽苦尤甜的工地生活',
        goPage : 26,
        page   : 21
    },
    {   
        name   :'09 最简单的工具',
        goPage : 30,
        page   : 25
    },
    {
        name 	: '第二章 伟大工程',
        section : true,
        goPage  : 33
    },
    {
        name   : '01 红旗渠工程总体规划',
        goPage : 34,
        page   : 28
    },
    {
        name   : '02 红旗渠重要工程',
        goPage : 36,
        page   : 30
    },
    {
        name 	: '第三章 梦想成真',
        section : true,
        goPage  : 47
    },
    {
        name   : '01 红旗渠不仅是林县的，更是中国的',
        goPage : 48,
        page   : 41
    },
    {
        name   : '02 祖祖辈辈的梦想变为现实',
        goPage : 50,
        page   : 43
    },
    {
        name   : '03 红旗渠水浇灌林县大地',
        goPage : 53,
        page   : 46
    },
    {
        name   : '04 幸福的生活',
        goPage : 57,
        page   : 50
    },
    {
        name 	: '第四章 精神永在',
        section : true,
        goPage  : 65
    },
    {
        name   : '01 总书记的关怀',
        goPage : 66,
        page   : 58
    },
    {
        name   : '02 新时代新林州',
        goPage : 70,
        page   : 62
    },
    {
        name   : '03 铭记历史',
        goPage : 76,
        page   : 68
    }
]

// pageData > 页面数据
//     section    > 是否是章节
//     title      > 每个章节的标题 || 每个页面的标题
//     videoUrl   > 章节顶部视频url
//     videoName  > 章节视频的名字
//     list       > 章节的所有目录
//     name       > 章节目录名字
//     goPage     > 章节目录索引位置
//     content    > 页面的内容
//     img_1      > 页面的第一张图片
//     img_2      > 页面的第二张图片
//     img_3      > 页面的第三张图片
//     img_1Title > 页面的第一张图片的标题
//     img_2Title > 页面的第二张图片的标题
//     img_3Title > 页面的第三张图片的标题
//     page       > 页面当前第几页
//     word       > 页面图文介绍
// navData  > 导航数据
//     name    > 每一个导航的名字
//     section > 是否是章节
//     goPage  > 索引位置
//     page    > 页面第几页